import { render, staticRenderFns } from "./WineMarketing.vue?vue&type=template&id=fd7a25a2&"
import script from "./WineMarketing.vue?vue&type=script&lang=ts&"
export * from "./WineMarketing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports